import { useEffect, useRef, useState } from 'react';
import { changeDeliveryCompany, changePrice, parseMarketOrderStatus, changeTelNumber } from '../../common/utils';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { HEADER_LIST } from './OrderTableData';
import Pagination from 'react-js-pagination';
import OrderInfoModal from './OrderInfoModal';
import loadingImg from '../../../img/loading.png';
import { motion, AnimatePresence } from 'framer-motion';
import moment from 'moment/moment';
const xlsx = require('xlsx');

const qs = require('qs');
const goPage = (path) => {
	Navigate(path);
};

function OrderTable(props) {
	const [HeaderList, setHeaderList] = useState([]);
	const [TableData, setTableData] = useState([]); // axios에서 받아온 전체 게시글 데이터
	const [Page, setPage] = useState(1); // 현재 페이지 번호
	const [PostPerPage, setPostPerPage] = useState(10); // 페이지 당 게시글 개수
	const [IsPostPerPageOpen, setIsPostPerPageOpen] = useState(false);
	const indexOfLastPost = Page * PostPerPage;
	const indexOfFirstPost = indexOfLastPost - PostPerPage;

	const [CourierList, setCourierList] = useState([]);
	const [OrderInfoData, setOrderInfoData] = useState({});
	const PageLengthList = [10, 50, 100, 500];
	const [IsAllCheck, setIsAllCheck] = useState(false);
	const [CheckedOrder, setCheckedOrder] = useState([]);
	const [IsLoading, setIsLoading] = useState(false);
	const recentParams = useRef();

	const handleOrderTableButtonProcess = async (e, type) => {
		e.preventDefault();
		const currentTableData = [...TableData];
		if (CheckedOrder && CheckedOrder.length > 0) {
			if (type === 'orderConfirmation') {
				let successCount = 0;
				let objectArr = [];
				let validObjectArr = [];
				for (let i = 0; i < CheckedOrder.length; i++) {
					objectArr.push(currentTableData.filter((el) => el.idx === CheckedOrder[i]));
				}
				objectArr = objectArr.map((el) => el[0]);
				// 2024-07-23 도매사 주문번호 없이도 발주확인 넘어갈 수 있도록 수정
				validObjectArr = objectArr//.filter((el) => el.vendorOrderId != null);
				if (CheckedOrder.length === validObjectArr.length) {
					console.log('발주확인 요청 주문List', CheckedOrder);
					/* eslint-disable no-restricted-globals */
					const isOk = confirm(`${CheckedOrder} 주문을 발주확인 처리하시겠습니까?`);
					/* eslint-enable no-restricted-globals */
					if (isOk) {
						console.log(`${CheckedOrder}리스트들 발주확인 요청`);
						const marketCodes = [];
						for (let i = 0; i < CheckedOrder.length; i++) {
							const updatedObject = currentTableData.filter((el) => el.idx === CheckedOrder[i])[0];
							try {
								updateOrder({
									idx: updatedObject.idx,
									target: 'vendorOrderId',
									value: updatedObject.vendorOrderId || '',
								});
								if (!marketCodes.includes(updatedObject.marketCode)) marketCodes.push(updatedObject.marketCode);
								successCount++;
								if (successCount === CheckedOrder.length) {
									setTimeout(() => {
										setIsLoading(false);
										alert('저장되었습니다.');
										setCheckedOrder([]);
									}, 2000);
								}
							} catch (error) { }
						}

						for (const marketCode of marketCodes) {
							axios.post(
								`${window.location.protocol}//${window.location.hostname}:3001/spread`,
								qs.stringify({
									token: localStorage.getItem('token'),
									mode: 'order',
									marketCode
								})
							)
						}
					} else {
						console.log(`발주확인 취소`);
					}
				} else {
					alert(`선택한 주문의 도매사 주문번호를 모두 입력해주세요.`);
				}
			} else if (type === 'placeAnOrder') {
				const orders = currentTableData.filter(f => CheckedOrder.includes(f.idx));
				if (!orders.filter(f => !['PAYED', 'ORDER_WAITING'].includes(f.marketOrderStatus) || f.vendorOrderStatus !== 'ORDER_WAITING').length) {
					/* eslint-disable no-restricted-globals */
					const isOk = confirm(`${CheckedOrder} 주문을 발주처리 하시겠습니까?`);
					/* eslint-enable no-restricted-globals */
					if (isOk) {
						let parseOrders = {};
						for (const data of orders) {
							const vendorCode = data.manageCode.split('_')[0];
							if (parseOrders[vendorCode]) parseOrders[vendorCode].push(data);
							else parseOrders[vendorCode] = [data];
						}

						for (const vendorCode in parseOrders) {
							axios({
								method: 'POST',
								url: `${window.location.protocol}//${window.location.hostname}:3001/glean`,
								data: {
									token: localStorage.getItem('token'),
									mode: 'order',
									vendorCode: [vendorCode],
									subject: parseOrders[vendorCode].map(m => m.productOrderId)
								},
								xhrFields: {
									withCredentials: true,
								},
							})
						}
					} else {
						console.log(`발주처리 취소`);
					}
				} else {
					alert(`선택한 주문중 올바르지 않는 주문 상태가 존재합니다.`);
				}
			} else if (type === 'shippingProcessing') {
				let successCount = 0;
				let objectArr = [];
				let deliveryCompanyValidObjectArr = [];
				let trackingNumberValidObjectArr = [];
				for (let i = 0; i < CheckedOrder.length; i++) {
					objectArr.push(currentTableData.filter((el) => el.idx === CheckedOrder[i]));
				}
				objectArr = objectArr.map((el) => el[0]);
				deliveryCompanyValidObjectArr = objectArr.filter((el) => el.deliveryCompany != null);
				trackingNumberValidObjectArr = objectArr.filter((el) => el.trackingNumber != null);
				if (
					CheckedOrder.length === deliveryCompanyValidObjectArr.length &&
					deliveryCompanyValidObjectArr.length === trackingNumberValidObjectArr.length
				) {
					console.log('발송처리 요청 주문List', CheckedOrder);
					/* eslint-disable no-restricted-globals */
					const isOk = confirm(`${CheckedOrder} 주문을 발송확인 처리하시겠습니까?`);
					/* eslint-enable no-restricted-globals */
					if (isOk) {
						console.log(`${CheckedOrder}리스트들 발송확인 요청`);
						const marketCodes = [];
						for (let i = 0; i < CheckedOrder.length; i++) {
							const updateData = currentTableData.filter((el) => el.idx === CheckedOrder[i])[0];
							try {
								updateOrder({
									idx: updateData.idx,
									target: 'trackingNumber',
									value: {
										deliveryCompany: updateData.deliveryCompany,
										trackingNumber: updateData.trackingNumber,
									},
								});
								if (!marketCodes.includes(updateData.marketCode)) marketCodes.push(updateData.marketCode);
								successCount++;
								if (successCount === CheckedOrder.length) {
									setTimeout(() => {
										setIsLoading(false);
										alert('저장되었습니다.');
										setCheckedOrder([]);
									}, 2000);
								}
							} catch (error) { }
						}

						for (const marketCode of marketCodes) {
							axios.post(
								`${window.location.protocol}//${window.location.hostname}:3001/spread`,
								qs.stringify({
									token: localStorage.getItem('token'),
									mode: 'order',
									marketCode
								})
							)
						}
					} else {
						console.log(`발송확인 취소`);
					}
				} else {
					alert(`선택한 주문의 택배사와 송장번호를 모두 입력해주세요.`);
				}
			} else if (type === 'orderCancel') {
				const orders = currentTableData.filter(f => CheckedOrder.includes(f.idx));
				console.log(orders);
				if (!orders.filter(f => !['PAYED', 'ORDER_WAITING', 'DELIVERY_WAITING'].includes(f.marketOrderStatus)).length) {
					console.log('취소처리 요청 주문List', CheckedOrder);
					/* eslint-disable no-restricted-globals */
					const isOk = confirm(`${CheckedOrder} 주문을 취소 처리하시겠습니까?`);
					/* eslint-enable no-restricted-globals */
					if (isOk) {
						let successCount = 0;
						console.log(`${CheckedOrder}리스트들 주문취소 요청`);
						const orderMap = {};
						currentTableData.filter(f => CheckedOrder.includes(f.idx)).forEach(row => {
							if (orderMap[row.marketCode]) orderMap[row.marketCode].push(row);
							else orderMap[row.marketCode] = [row];
						});

						for (const marketCode in orderMap) {
							const cancelMap = {};
							orderMap[marketCode].forEach(row => {
								if (cancelMap[row.marektID]) cancelMap[row.marketID].push(row);
								else cancelMap[row.marketID] = [row];
							})

							for (const marketId in cancelMap) {
								const subject = cancelMap[marketId].map(m => m.productOrderId);
								axios({
									method: 'POST',
									url: `${window.location.protocol}//${window.location.hostname}:3001/spread`,
									data: {
										token: localStorage.getItem('token'),
										mode: 'cancel',
										marketCode,
										marketId,
										subject
									},
									xhrFields: {
										withCredentials: true,
									},
								})
								successCount++;
								if (successCount === CheckedOrder.length) {
									setTimeout(() => {
										setIsLoading(false);
										alert('저장되었습니다.');
										setCheckedOrder([]);
									}, 2000);
								}
							}
						}
					} else {
						console.log(`취소처리 취소`);
					}
				} else {
					alert(`선택한 주문중 올바르지 않는 주문 상태가 존재합니다.`);
				}
			}
		} else {
			alert('주문을 선택해주세요.');
		}
	};
	const handleInputChange = (e, type, index) => {
		try {
			let updatedData = [...TableData];
			let updatedObjectIdx = index;
			let updatedObject = {};
			for (let i = 0; i < updatedData.length; i++) {
				if (updatedData[i].idx === updatedObjectIdx) {
					updatedObject = updatedData[i]; //객체 참조
					break;
				}
			}
			if (updatedObject && Object.keys(updatedObject).length > 0) {
				console.log('updatedObject: ', updatedObject);
				switch (type) {
					case 'deliveryCompany':
						updatedObject[type] = e.target.innerText;
						break;
					case 'isDropBoxOpen':
						updatedObject[type] = !updatedObject[type];
						break;
					case 'trackingNumber':
						const input = e.target.value;
						const sanitizedInput = input.replace(/[^0-9]/g, ''); //숫자만 작성가능
						updatedObject[type] = sanitizedInput;
						break;
					default:
						// vendorOrderId
						updatedObject[type] = e.target.value.trim();
				}
			} else {
				throw new Error('Object not found');
			}
			setTableData(updatedData);
		} catch (error) {
			console.error('Error handling input:', error);
		}
	};

	const handleBlurContainer = (e, index, type) => {
		if (type === 'tableDropbox') {
			const updatedData = [...TableData];
			for (let i = 0; i < TableData.length; i++) {
				if (TableData[i].idx === index) {
					updatedData[i].isDropBoxOpen = !updatedData[i].isDropBoxOpen;
				} else {
					updatedData[i].isDropBoxOpen = false;
				}
			}
			setTimeout(() => {
				setTableData(updatedData);
			}, 200);
		} else {
			//PostPerPage
			setTimeout(() => {
				setIsPostPerPageOpen(false);
			}, 200);
		}
	};

	const updateOrder = (config) => {
		console.log('updateOrder config확인', config);
		setIsLoading(true);
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/updateOrder`,
			data: {
				token: localStorage.getItem('token'),
				config,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				console.log('updateOrder response: ', res);
			})
			.catch((error) => { });
	};

	const cancelOrder = (config) => {
		console.log('cancelOrder config확인', config);
		setIsLoading(true);
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/cancelOrder`,
			data: {
				token: localStorage.getItem('token'),
				config,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				console.log('cancelOrder response: ', res);
			})
			.catch((error) => { });
	};

	const handleModalOpen = (item, index) => {
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/getOrders`,
			data: {
				token: localStorage.getItem('token'),
				config: {
					productOrderId: item.productOrderId,
				},
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				setOrderInfoData(res.data.orderInfo[0]);
				handleModalContainer(index);
			})
			.catch();
	};
	const handleModalContainer = (index) => {
		const updatedData = [...TableData];
		for (let i = 0; i < TableData.length; i++) {
			if (TableData[i].idx === index) {
				updatedData[i].isOrderInfoModalOpen = !updatedData[i].isOrderInfoModalOpen;
			} else {
				updatedData[i].isOrderInfoModalOpen = false;
			}
		}
		setTimeout(() => {
			setTableData(updatedData);
		}, 200);
	};

	const handlePageChange = (page) => {
		if (Page !== page) {
			setCheckedOrder([]);
			setIsAllCheck(false);
			return setPage(page);
		}
	};
	const exportToExcel = () => {
		if (TableData) {
			const originalTableData = TableData;
			// 새로운 데이터 키값과 헤더
			const newDataKeys = {
				marketCode: '마켓',
				marketID: '아이디',
				orderId: '주문번호',
				productOrderId: '상품 주문번호',
				vendorOrderId: '도매사 주문번호',
				trackingNumber: '송장번호',
				deliveryCompany: '택배사',
				marketOrderStatus: '마켓주문상태',
				paymentDate: '주문일시',
				manageCode: '상품관리코드',
				productName: '상품명',
				productOption: '옵션명',
				quantity: '수량',
				totalPaymentAmount: '결제금액',
				expectedSettlementAmount: '정산예정금액',
				orderAmount: '발주금액',
				deliveryFeeAmount: '배송비합계',
				receiverName: '수취인명',
				receiverTel1: '수취인 연락처1',
				receiverTel2: '수취인 연락처2',
				zipCode: '우편번호',
				baseAddress: '수취인 주소1',
				detailedAddress: '수취인 주소2',
				shippingMemo: '배송 메시지'
			};

			// 데이터 키값 변경
			const modifiedTableData = originalTableData.map((item) => {
				const newItem = {};
				for (const key in item) {
					if (key in newDataKeys) {
						// 특정 키값을 변환해서 보내야할 때 아래 조건문 추가
						if (key === 'marketOrderStatus') {
							newItem[newDataKeys[key]] = parseMarketOrderStatus(item[key]);
						} else if (key === 'paymentDate') {
							newItem[newDataKeys[key]] = item[key];
						} else if (key === 'deliveryCompany') {
							newItem[newDataKeys[key]] = changeDeliveryCompany(item[key]);
						} else if (key.indexOf('receiverTel') === 0) {
							newItem[newDataKeys[key]] = changeTelNumber(item[key]);
						} else {
							if (item[key]) {
								newItem[newDataKeys[key]] = `${item[key]}`;
							} else {
								newItem[newDataKeys[key]] = '-';
							}
						}
					}
				}
				console.log('엑셀 - 변환한 행 데이터', newItem);
				return newItem;
			});

			const ws = xlsx.utils.json_to_sheet(modifiedTableData, {
				skipHeader: false, // 첫 번째 행을 열의 제목으로 사용함
			});

			ws['!cols'] = [
				{ wch: 20 }, // A열
				{ wch: 20 }, // B열
				{ wch: 20 }, // C열
				{ wch: 20 }, // D열
				{ wch: 20 }, // E열
				{ wch: 20 }, // F열
				{ wch: 20 }, // G열
				{ wch: 20 }, // H열
				{ wch: 20 }, // I열
				{ wch: 20 }, // J열
				{ wch: 20 }, // K열
				{ wch: 20 }, // L열
				{ wch: 20 }, // M열
				{ wch: 20 }, // N열
				{ wch: 20 }, // O열
			];
			// 워크북 생성 및 시트 추가
			const wb = xlsx.utils.book_new();
			xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
			xlsx.writeFile(wb, `aios_order_list_v1_${moment().format('YYYYMMDDHH')}.xlsx`); //두번쨰 인수는 파일 이름.
		}
	};
	const setParams = (params) => {
		console.log('검색 조건 파라미터', params);
		setHeaderList(HEADER_LIST);
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/getOrders`,
			data: {
				token: localStorage.getItem('token'),
				config: params,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				const DataArray = res.data.orderInfo?.map((obj, index) => {
					return {
						...obj,
						isDropBoxOpen: false,
						isOrderInfoModalOpen: false,
						isOrderDetailModalOpen: false,
						index: index + 1,
					};
				});
				setPage(1);
				setCheckedOrder([]);
				setTableData(DataArray || []);
			})
			.catch(function (error) {
				console.log(error);
			});

		setCourierList([
			{ text: '한진택배', value: 'HANJIN' },
			{ text: '롯데택배', value: 'HYUNDAI' },
			{ text: 'CJ대한통운', value: 'CJGLS' },
			{ text: '경동택배', value: 'KDEXP' },
			{ text: '대신택배', value: 'DAESIN' },
			{ text: '로젠택배', value: 'KGB' },
			{ text: '우체국택배', value: '-' },
			{ text: '농협택배', value: '-' },
			{ text: '전일배송', value: '-' },
			{ text: '건영택배', value: '-' },
			{ text: '자체배송', value: '-' },
		]);
	};
	const handleBlurPageSizeContainer = () => {
		setTimeout(() => {
			setIsPostPerPageOpen(!IsPostPerPageOpen);
		}, 200);
	};
	const handlePostPerPageOpen = () => {
		setIsPostPerPageOpen(!IsPostPerPageOpen);
	};
	const handlePostPerPage = (e, value) => {
		const newPerPageSize = value;
		if (PostPerPage !== newPerPageSize) {
			setPage(1);
			setPostPerPage(newPerPageSize);
			return;
		}
	};
	useEffect(() => {
		const nowTableIdxArray = TableData?.slice(indexOfFirstPost, indexOfLastPost).map(
			(el) => el.idx
		);
		const nowPageChecked = nowTableIdxArray.filter((item) => CheckedOrder.includes(item));
		if (nowTableIdxArray.length === nowPageChecked.length && TableData.length) {
			setIsAllCheck(true);
		} else {
			setIsAllCheck(false);
		}
	}, [Page, CheckedOrder]);
	const handleCheckAllCommodity = (e) => {
		const checkedArray = TableData?.slice(indexOfFirstPost, indexOfLastPost).map((el) => el.idx);
		if (e.target.checked) {
			setIsAllCheck(true);
			let newArray = [];
			newArray = CheckedOrder.concat(checkedArray);
			newArray = newArray.filter((value, index, self) => self.indexOf(value) === index);
			setCheckedOrder(newArray);
		} else {
			let newArray = CheckedOrder.filter((item) => !checkedArray.includes(item));
			setIsAllCheck(false);
			setCheckedOrder(newArray);
		}
	};
	const handleCheckedOrder = (e) => {
		const newValue = Number(e.target.value);
		let newCheckedOrder = [];
		if (e.target.checked) {
			newCheckedOrder = [...CheckedOrder, newValue];
		} else {
			newCheckedOrder = CheckedOrder.filter((item) => item !== newValue);
		}
		setCheckedOrder(newCheckedOrder);
	};
	const handleVendorSite = (url) => {
		console.log('상품 주소 ', url);
		if (url != null) window.open(url, '_blank', 'noopener, noreferrer');
	};
	useEffect(() => {
		if (Object.keys(props.params).length > 0) {
			const params = props.params; //config: qs.stringify({params})
			setParams(params);
			recentParams.current = params;
		}
	}, [props.params]);
	useEffect(() => {
		if (Object.keys(props.countParams).length > 0) {
			const params = props.countParams; //config: qs.stringify({params})
			setParams(params);
			recentParams.current = params;
		}
	}, [props.countParams]);

	return (
		<>
			<div className='order-table'>
				<div className='table-top'>
					<div className='table-top-left'>
						<p>
							총 <span className='pointText'>{TableData.length}</span>건
						</p>
						<button onClick={(e) => handleOrderTableButtonProcess(e, 'placeAnOrder')}>
							도매사 발주
						</button>
						<button onClick={(e) => handleOrderTableButtonProcess(e, 'orderConfirmation')}>
							마켓 발주확인
						</button>
						<button onClick={(e) => handleOrderTableButtonProcess(e, 'shippingProcessing')}>
							마켓 발송처리
						</button>
						<button onClick={(e) => handleOrderTableButtonProcess(e, 'orderCancel')}>
							마켓 취소처리
						</button>
					</div>
					<div className='table-top-right'>
						<div className='container' onBlur={(e) => handleBlurPageSizeContainer(e)}>
							<label onClick={() => handlePostPerPageOpen()}>
								<button className='dropdown-button'>
									<span>{PostPerPage}개씩</span>
									<span className='dropdown-button-arrow'>{IsPostPerPageOpen ? '▲' : '▼'}</span>
								</button>
							</label>
							{IsPostPerPageOpen && (
								<div
									className={IsPostPerPageOpen ? 'dropdown-container open' : 'dropdown-container'}
								>
									<ul className='dropdown-content'>
										{PageLengthList.map((el, idx) => (
											<li key={idx} onClick={(e) => handlePostPerPage(e, el)}>
												{el}개씩
											</li>
										))}
									</ul>
								</div>
							)}
						</div>
						<button onClick={exportToExcel} style={{ marginLeft: '10px' }}>
							엑셀다운로드
						</button>
					</div>
				</div>
				<table>
					<thead>
						<tr>
							{HeaderList.map((el, index) => {
								if (el === '선택') {
									return (
										<th key={index}>
											<input
												type='checkbox'
												checked={IsAllCheck}
												onChange={(e) => handleCheckAllCommodity(e)}
											/>
										</th>
									);
								} else {
									return <th key={index}>{el}</th>;
								}
							})}
						</tr>
					</thead>
					<tbody>
						{TableData.length === 0 && (
							<tr className='defaultTable'>
								<td colSpan={HEADER_LIST.length}>
									<div>데이터가 없습니다.</div>
								</td>
							</tr>
						)}
						{IsLoading && (
							<AnimatePresence>
								<motion.tr
									initial={{ opacity: 0 }}
									animate={{ opacity: 1, transition: { duration: 0.2 } }}
									exit={{ opacity: 0, transition: { delay: 0.1, duration: 0.1 } }}
									className='loading'
								>
									<td colSpan={HEADER_LIST.length}>
										{/* <a
												href='https://www.flaticon.com/kr/free-icons/'
												title='로딩 아이콘'
												style={{ display: 'none' }}
											>
												로딩 아이콘 제작자: Krystsina Mikhailouskaya - Flaticon
											</a> */}
										<img src={loadingImg} alt='로딩아이콘' className='loadingImg' />
									</td>
								</motion.tr>
							</AnimatePresence>
						)}
						{TableData?.slice(indexOfFirstPost, indexOfLastPost).map((item) => (
							<tr key={item.idx}>
								{/* 선택 */}
								<td>
									<input
										type='checkbox'
										value={item.idx}
										checked={CheckedOrder?.includes(item.idx)}
										onChange={(e) => {
											handleCheckedOrder(e);
										}}
									/>
								</td>
								{/**마켓*/}
								<td>{item.marketCode}</td>
								{/**아이디*/}
								<td>{item.marketID}</td>
								{/**주문번호*/}
								<td>{item.orderId}</td>
								<td>
									{/**상품 주문번호*/}
									<span onClick={() => handleModalOpen(item, item.idx)} className='clickTd'>
										{item.productOrderId}
									</span>
									{item.isOrderInfoModalOpen && (
										<OrderInfoModal
											data={OrderInfoData}
											getOrderInfoModalOpen={() => {
												handleModalContainer(item.idx);
												setParams(recentParams.current);
											}}
										/>
									)}
								</td>
								<td>
									{/**도매사 주문번호*/}
									<div className='tdInput'>
										<input
											type='text'
											value={item.vendorOrderId || ''}
											onChange={(e) => handleInputChange(e, 'vendorOrderId', item.idx)}
										/>
									</div>
								</td>
								<td>
									{/**택배사 */}
									<div className='deliveryCompanyTrackingNumber'>
										<div
											className='container'
											onBlur={(e) => handleBlurContainer(e, item.idx, 'tableDropbox')}
											style={{ marginRight: '5px' }}
										>
											<label onClick={(e) => handleInputChange(e, 'isDropBoxOpen', item.idx)}>
												<button className='dropdown-button'>
													<span>
														{item.deliveryCompany
															? changeDeliveryCompany(item.deliveryCompany)
															: '택배사'}
													</span>
													<span className='dropdown-button-arrow'>
														{item.isDropBoxOpen ? '▲' : '▼'}
													</span>
												</button>
											</label>
											{item.isDropBoxOpen && (
												<div
													className={
														item.isDropBoxOpen ? 'dropdown-container open' : 'dropdown-container'
													}
												>
													<ul className='dropdown-content'>
														{CourierList.map((el, idx) => (
															<li
																key={idx}
																onClick={(e) => handleInputChange(e, 'deliveryCompany', item.idx)}
															>
																{el.text}
															</li>
														))}
													</ul>
												</div>
											)}
										</div>
										{/**송장번호 */}
										<div className='tdInput'>
											<input
												type='text'
												value={item.trackingNumber || ''}
												onChange={(e) => handleInputChange(e, 'trackingNumber', item.idx)}
											/>
										</div>
									</div>
								</td>
								<td>
									{/**마켓주문상태 */}
									{parseMarketOrderStatus(item.marketOrderStatus)}
								</td>
								<td>
									{/**주문일시 */}
									{moment(item.paymentDate).format('YYYY-MM-DD HH:mm:ss')}
								</td>
								<td>
									{/**상품관리코드 */}
									<span className='clickTd' onClick={() => handleVendorSite(item.originUrl)}>
										{item.manageCode}
									</span>
								</td>
								<td>
									{/**수취인명 */}
									{item.receiverName}
								</td>
								<td>
									{/**결제금액 */}
									{changePrice(item.totalPaymentAmount)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<Pagination
					activePage={Page}
					itemsCountPerPage={Number(PostPerPage)}
					totalItemsCount={TableData.length}
					pageRangeDisplayed={10}
					prevPageText={'‹'}
					nextPageText={'›'}
					onChange={handlePageChange}
				/>
			</div>
		</>
	);
}

export default OrderTable;
